export default function Footer() {
  return (
    <footer className="bg-black border-t border-red-500/20 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-red-500/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-orange-500/20 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 py-16 relative">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div className="md:col-span-2">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-red-500 via-orange-500 to-yellow-500 rounded-full flex items-center justify-center shadow-xl shadow-red-500/50 border-2 border-red-400/50">
                  <i className="ri-megaphone-line text-3xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-4xl font-black text-white" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                    Office <span className="bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">WoW</span>
                  </h3>
                  <p className="text-red-400 text-sm font-semibold tracking-wide" style={{ fontFamily: '"Montserrat", sans-serif' }}>Creative Advertising Agency</p>
                </div>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                革新的な発想と戦略的思考で、<br />
                クライアントのビジネスに「WoW（驚き）」をもたらす<br />
                広告ソリューションを提供し続けています。
              </p>
            </div>

            <div>
              <h4 className="text-white font-black mb-6 text-xl" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>Services</h4>
              <ul className="space-y-3" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-red-400 transition-colors text-sm font-medium">
                    ブランディング
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-red-400 transition-colors text-sm font-medium">
                    広告制作
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-red-400 transition-colors text-sm font-medium">
                    デジタルマーケティング
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-red-400 transition-colors text-sm font-medium">
                    映像制作
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-red-400 transition-colors text-sm font-medium">
                    Webサイト制作
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-red-400 transition-colors text-sm font-medium">
                    イベント企画
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-black mb-6 text-xl" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>Company</h4>
              <ul className="space-y-3" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                <li>
                  <a href="#about" className="text-gray-400 hover:text-red-400 transition-colors text-sm font-medium">
                    会社概要
                  </a>
                </li>
                <li>
                  <a href="#portfolio" className="text-gray-400 hover:text-red-400 transition-colors text-sm font-medium">
                    実績紹介
                  </a>
                </li>
                <li>
                  <a href="#contact" className="text-gray-400 hover:text-red-400 transition-colors text-sm font-medium">
                    お問い合わせ
                  </a>
                </li>
                <li>
                  <a href="/privacy" className="text-gray-400 hover:text-red-400 transition-colors text-sm font-medium">
                    プライバシーポリシー
                  </a>
                </li>
                <li>
                  <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-400 transition-colors text-sm font-medium">
                    Website Builder
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-red-500/20 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-500 text-sm" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                &copy; 2025 合同会社オフィスWoW All rights reserved.
              </p>
              <div className="text-gray-500 text-sm" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                神奈川県相模原市南区松が枝町1番25号
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}